import { type Common } from '../common.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';
import {
  type DetailedLinkedUser,
  type FindAllOptions,
  type LinkedUser,
} from '../models/user/linkedUser.js';

export class API {
  common: Common;
  baseEndpoint = '/user-linked-users';

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: {
    parentUserId: string;
    linkedUserId: string;
    ticketUrl: string;
  }): Promise<LinkedUser> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<DetailedLinkedUser>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async impersonate(body: { userId: string }): Promise<any> {
    const url = this.common.constructPath(`${this.baseEndpoint}/impersonate`);
    return await this.common.postJSON(url, body);
  }

  async stopImpersonation(): Promise<any> {
    const url = this.common.constructPath(`${this.baseEndpoint}/stop-impersonation`);
    return await this.common.postJSON(url, {});
  }

  async remove(id: string, ticketUrl: string): Promise<any> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.postJSON(url, { ticketUrl }, 'DELETE');
  }
}
